export const normalizeHtml = (html) => {
    html = html.replaceAll(`<font face="Times New Roman" size="3"`, `<font face="Times New Roman" size="1"`)
    while (html.indexOf('  ') > 0)
        html = html.replaceAll('  ', ' ');
    html = html.replaceAll('; ', ';');
    html = html.replaceAll(': ', ':');

    html = html.replaceAll(`<font face="Times New Roman" size="3"`, `<font face="Times New Roman" size="1"` ); 
    html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,serif;mso-fareast-font-family:&quot;Times New Roman&quot;;`, `` )
    // //font-family: &quot;Times New Roman&quot;,serif;mso-fareast-font-family:&quot;Times New Roman&quot;      
    //html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,serif;mso-fareast-font-family:&quot;Times New Roman&quot;`, `` )
    html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,serif`, ``);
    html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,serif;mso-bidi-font-family:Mangal;`, ``)
    html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,serif;`, ``)
    //html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,serif;`, ``);
    html = html.replaceAll(`font-family:&quot;Times New Roman&quot;,&quot;serif&quot;`, ``)  
    html = html.replaceAll(';mso-fareast-font-family:TimesNewRomanPSMT', '');
    html = html.replaceAll(' class="MsoTableGrid"', '');
    html = html.replaceAll(' class="MsoNormal"', '');
    html = html.replaceAll('class="MsoNormalTable"', '');                        
    html = html.replaceAll(';mso-ansi-language:KZ', '');
    html = html.replaceAll(' class="MsoNormalCxSpMiddle"', '');
    html = html.replaceAll(';mso-bidi-theme-font:minor-bidi', '');
    html = html.replaceAll(' class="MsoNoSpacing"', '');
    html = html.replaceAll('<p>​</p>', '');
    html = html.replaceAll('mso-fareast-font-family:Calibri', 'mso-fareast-font-family:Times New Roman')
    //font-family:Symbol;
    // html = html.replaceAll('font-family:&quot;Calibri&quot', 'font-family:&quot;Times New Roman&quot')
    // html = html.replaceAll('font-family:&quot;Helvetica Neue&quot', 'font-family:&quot;Times New Roman&quot')
    html = html.replaceAll(/font-family:&quot;[\w,\s]*&quot/g, 'font-family:&quot;Times New Roman&quot')
    html = html.replaceAll(/font-family:[\w,\s]*;/g, 'font-family:Times New Roman;')
    html = html.replaceAll(/font:[\w,\s,.]*pt &quot;[\w,\s]*&quot/g, '')
    html = html.replaceAll(';font-size:inherit', '');
    html = html.replaceAll('text-decoration:none', '');

    // Восстановление степеней: заменяем паттерны типа "5x102", "5*102" на "5x10²", "5*10²"
    // Обрабатываем только случаи научной нотации
    html = html.replace(/(\d+)([x*])10([2-9])(\d*)/g, (match, num, separator, power, rest) => {
        const superscripts = {'2': '²', '3': '³', '4': '⁴', '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹'};
        return `${num}${separator}10${superscripts[power]}${rest}`;
    });
    // ВАЖНО: не преобразуем голые числа вида 109 -> 10⁹.
    // Степени восстанавливаем только в явной научной нотации через x/* (правило выше).

    //

    // /font:[\w,\s,.]*pt &quot;[\w,\s]*&quot/g
    //&quot;Times New Roman&quot
    //font:7.0pt &quot;Times New Roman&quot

    return html;
}

function collapseRepeatedFragment(fragment) {
    if (!fragment || fragment.length < 8) {
        return fragment;
    }
    if (!/<br\s*\/?>/i.test(fragment)) {
        return fragment;
    }
    if (/<(?!br\s*\/?>)[^>]*>/i.test(fragment)) {
        return fragment;
    }

    for (let times = 4; times >= 2; times--) {
        if (fragment.length % times !== 0) {
            continue;
        }
        const unit = fragment.slice(0, fragment.length / times);
        if (unit.length < 4 || !/<br\s*\/?>/i.test(unit)) {
            continue;
        }
        if (unit.repeat(times) === fragment) {
            return unit;
        }
    }

    return fragment;
}

/**
 * Убирает ошибочно повторённые двуязычные подписи в ячейках таблиц протоколов.
 * Пример: "Қаз<br>РусҚаз<br>РусҚаз<br>Рус" → "Қаз<br>Рус"
 */
export function collapseRepeatedTableCellText(html) {
    if (!html || typeof html !== 'string') {
        return html;
    }

    return html.replace(
        /(<(?:font|p|div|span|td|th)\b[^>]*>)([^<]*(?:<br\s*\/?>[^<]*)+)(<\/\s*(?:font|p|div|span|td|th)\s*>)/gi,
        (match, open, inner, close) => open + collapseRepeatedFragment(inner) + close
    );
}